module.exports = __webpack_public_path__ + "static/media/Gilroy-ExtraBold-Italic.29db72ec.woff";